var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-bar"},[_c('i',{staticClass:"return-btn van-icon van-icon-arrow-left",on:{"click":_vm.handleBackBtnClick}}),_vm._l((_vm.routes),function(item){return [(item.meta.title !== '首页')?_c('span',{key:item.path},[_vm._v(" "+_vm._s(item.meta.title))]):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }